import { addMinutes, subMinutes } from "date-fns";

type DemoVisitStatus = "canceled" | "scheduled" | "en_route" | "arrived" | "in_progress" | "complete";

type VisitPartial<T extends string> =
  DemoVisitStatus extends T
    ? {
        startTime: Date;
        endTime: Date;
        driveTime?: number;
        eventStatus?: T;
      }
    : never;

export const demoVisitStatus = <StatusType extends string>(visit: VisitPartial<StatusType>, demoTime: Date): DemoVisitStatus => {
  if(visit.eventStatus === "canceled") {
    return "canceled";
  }
  
  if(demoTime > visit.endTime) {
    return "complete";
  }

  if(demoTime > addMinutes(visit.startTime, 5)) {
    return "in_progress";
  } 

  if(demoTime > visit.startTime) {
    return "arrived";
  }

  if(visit.driveTime && demoTime > subMinutes(visit.startTime, visit.driveTime)) {
    return "en_route";
  }

  return "scheduled";
}